"use strict";
/**
 * Outline ↔ note cross-links stored in pnBody bullet labels.
 *
 * Convention (dogfood v1): trailing tags on a map node
 *   - Work item <t: 49033>
 *   - Phase playlist <t: 12> <t: 34> (+)
 *
 * Not the same as Thread membership (many-to-many thread_member).
 * These tags walk the outline into other note bodies; threads remain
 * durable invoice/epic/phase sets. See docs/product/outline-thread-links.md
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeOutlineLabelEdit = exports.outlineThreadLinkViewUrl = exports.removeOutlineThreadLink = exports.appendOutlineThreadLink = exports.formatOutlineThreadTag = exports.parseOutlineThreadLinks = exports.OUTLINE_THREAD_LINK_RE = void 0;
/** Matches `<t: 49033>` or `<t:49033>` (optional space after colon). */
exports.OUTLINE_THREAD_LINK_RE = /<t:\s*(\d+)\s*>/gi;
/**
 * Split a bullet label into display text + thread link ids.
 * Tags may appear anywhere; trailing is preferred by attach helpers.
 */
function parseOutlineThreadLinks(label) {
    var raw = label == null ? '' : String(label);
    var pnids = [];
    var seen = new Set();
    var m;
    var re = new RegExp(exports.OUTLINE_THREAD_LINK_RE.source, 'gi');
    while ((m = re.exec(raw)) !== null) {
        var id = m[1];
        if (!seen.has(id)) {
            seen.add(id);
            pnids.push(id);
        }
    }
    var cleanLabel = raw
        .replace(exports.OUTLINE_THREAD_LINK_RE, ' ')
        .replace(/[ \t]{2,}/g, ' ')
        .replace(/\s+$/g, '')
        .replace(/^\s+/g, '');
    return { cleanLabel: cleanLabel, pnids: pnids };
}
exports.parseOutlineThreadLinks = parseOutlineThreadLinks;
/** Format one tag: always space after colon for readability. */
function formatOutlineThreadTag(pnid) {
    var id = String(pnid).trim();
    if (!/^\d+$/.test(id)) {
        throw new Error('Thread link pnid must be numeric');
    }
    return "<t: ".concat(id, ">");
}
exports.formatOutlineThreadTag = formatOutlineThreadTag;
/**
 * Append `<t: id>` if not already present. Keeps existing tags; adds at end.
 */
function appendOutlineThreadLink(label, pnid) {
    var id = String(pnid).trim();
    if (!/^\d+$/.test(id)) {
        throw new Error('Thread link pnid must be numeric');
    }
    var base = label == null ? '' : String(label);
    var pnids = parseOutlineThreadLinks(base).pnids;
    if (pnids.indexOf(id) >= 0) {
        return base.replace(/\s+$/g, '');
    }
    var trimmed = base.replace(/\s+$/g, '');
    var tag = formatOutlineThreadTag(id);
    return trimmed ? "".concat(trimmed, " ").concat(tag) : tag;
}
exports.appendOutlineThreadLink = appendOutlineThreadLink;
/** Remove all tags for this pnid. */
function removeOutlineThreadLink(label, pnid) {
    var id = String(pnid).trim();
    var raw = label == null ? '' : String(label);
    var re = new RegExp("\\s*<t:\\s*".concat(id, "\\s*>"), 'gi');
    return raw
        .replace(re, '')
        .replace(/[ \t]{2,}/g, ' ')
        .replace(/\s+$/g, '')
        .replace(/^\s+/g, '');
}
exports.removeOutlineThreadLink = removeOutlineThreadLink;
function outlineThreadLinkViewUrl(pnid) {
    return "/view/pnid/".concat(String(pnid).trim());
}
exports.outlineThreadLinkViewUrl = outlineThreadLinkViewUrl;
/**
 * Build stored bullet label after map label edit:
 * clean text + previous `<t: id>` tags (chips) + any tags typed in the draft.
 * Does not parse checkbox markers — caller uses parseOutlineEditDraft first.
 */
function mergeOutlineLabelEdit(prevLabel, draftLabel) {
    var prevPnids = parseOutlineThreadLinks(prevLabel).pnids;
    var draftLinks = parseOutlineThreadLinks(draftLabel);
    var label = draftLinks.cleanLabel;
    for (var i = 0; i < prevPnids.length; i++) {
        try {
            label = appendOutlineThreadLink(label, prevPnids[i]);
        }
        catch (_a) {
            /* ignore invalid */
        }
    }
    for (var i = 0; i < draftLinks.pnids.length; i++) {
        try {
            label = appendOutlineThreadLink(label, draftLinks.pnids[i]);
        }
        catch (_b) {
            /* ignore invalid */
        }
    }
    return label;
}
exports.mergeOutlineLabelEdit = mergeOutlineLabelEdit;
